import { apigClient } from "@/shared/api";
import { companyService } from "../_services";
import { userPool } from "@/shared/cognito";

const AmazonCognitoIdentity = require("amazon-cognito-identity-js");

export const userService = {
  loginCognitoUser,
  setLoginUser,
  logout,
  setCapability
};

function loginCognitoUser(username, password) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password })
  };

  return new Promise((resolve, reject) => {
    setTimeout(() => {
      let params = JSON.parse(requestOptions.body);
      var authenticationDetails = new AmazonCognitoIdentity.AuthenticationDetails(
        {
          Username: params.username,
          Password: params.password
        }
      );
      var userData = {
        Username: params.username,
        Pool: userPool
      };
      var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
      var errorJson = { error: "Authentication failed" };
      try {
        if (authenticationDetails) {
          cognitoUser.authenticateUser(
            authenticationDetails,
            {
              onSuccess: function(userResult) {
                var JwtTokenAccess = userResult.getAccessToken().getJwtToken();
                var JwtTokenId = userResult.getIdToken().getJwtToken();
                var JwtTokenRefresh = userResult.getRefreshToken().getToken();
                let user = userResult;
                let responseJson = {
                  login_username: username,
                  cognito: {
                    token: JwtTokenAccess,
                    tokenId: JwtTokenId,
                    tokenRefresh: JwtTokenRefresh
                  },
                  db: {
                    id: user["idToken"]["payload"]["sub"],
                    role_id: user["idToken"]["payload"]["custom:role_id"],
                    roleName: user["idToken"]["payload"]["custom:roleName"],
                    group_id: user["idToken"]["payload"]["custom:group_id"],
                    groupName: user["idToken"]["payload"]["custom:groupName"],
                    timezone: user["idToken"]["payload"]["custom:timezone"],
                    company: {
                      id: user["idToken"]["payload"]["custom:company_id"],
                      name: null,
                      website: null,
                      prefix: null,
                      shortname: null,
                      subdomain: null,
                      fulldomain: null
                    }
                  }
                };
                user = responseJson;
                if (user.cognito.token) {
                  localStorage.setItem("loginUserInfo", JSON.stringify(user));
                  resolve({
                    ok: true,
                    role_id: user.db.role_id,
                    company_id: user.db.company.id
                  });
                }
              },
              onFailure: function() {
                reject({
                  error: true,
                  message: errorJson.error
                });
              }
            },
            true
          );
        }
        return;
      } catch (err) {
        reject({
          error: true,
          message: err
        });
      }
    });
  });
}

function setLoginUser(user) {
  return new Promise((resolve, reject) => {
    let loginUserInfo = JSON.parse(localStorage.getItem("loginUserInfo"));
    const method = "GET";
    const pathTemplate = "/roles/" + user.role_id;
    const additionalParams = {};
    const pathParams = {};
    apigClient
      .invokeApi(pathParams, pathTemplate, method, additionalParams)
      .then(function(result) {
        const roleData = result["data"]["data"];
        loginUserInfo.db.userCapabilities = roleData.roleCapabilities;
        loginUserInfo.db.userPermissionsBasedOnEntity =
          roleData.roleCapabilitiesForEachPermissionBaseName;
        companyService.setLoginCompany(user.company_id);
        if (
          loginUserInfo.db.userCapabilities &&
          loginUserInfo.db.userPermissionsBasedOnEntity
        ) {
          localStorage.setItem("loginUserInfo", JSON.stringify(loginUserInfo));
        }
        resolve({ ok: true });
      })
      .catch(function(err) {
        console.log("err " + err);
        reject({ ok: false });
      });
  });
}

async function setCapability(role_id) {
  setTimeout(() => {
    const method = "GET";
    const pathTemplate = "/roles/" + role_id;
    const additionalParams = {};
    const pathParams = {};
    apigClient
      .invokeApi(pathParams, pathTemplate, method, additionalParams)
      .then(function(result) {
        const roleData = result["data"]["data"];
        console.log(roleData.roleCapabilities);
        return {
          capabilities: roleData.roleCapabilities
        };
      })
      .catch(function(error) {
        console.log("ERROR ! Cannot get data:" + error);
      });
  });
}

function logout() {
  localStorage.clear();
}
